import { CategoryTree } from '@/lib/graphql/generated/graphql';
import { atom } from 'jotai';

export const categoryTreeMapState = atom<Record<string, string>>({});
export const categoryTreeState = atom<CategoryTree[]>([]);
// Tracks which language the categoryTree was last loaded for (to skip on navigation remount)
export const categoryTreeLoadedForLanguageAtom = atom<string | null>(null);
